
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.113 60c10.004 0 18.114-8.16 18.114-18.227V17.107c2.841 4.365 7.744 7.24 13.31 7.24.5 0 .981-.033 1.463-.066v-9.983C47.306 13.746 41.14 7.676 40.343 0h-8.525l-.083 41.89c0 5.133-4.503 9.18-9.622 9.18-5.118 0-9.24-4.164-9.24-9.297 0-5.134 4.139-9.298 9.24-9.298.383 0 .748.067 1.114.117v-8.98c-.366-.017-.748-.05-1.114-.05C12.11 23.545 4 31.706 4 41.772 4 51.84 12.11 60 22.113 60z"}})])
          )
        }
      }
    